import { Theme } from "@mui/material";
import { isUndefinedorEmpty } from "../features/transformer/UnregisteredFunctions";
import { connectionProfileType, IntegrationEntity, IntegrationSchedule, RemoteFileInfo, IntegrationFileInfo, RemoteStreamLoadFile, IntegrationMapper, SalesMapperRequest, IntegrationJobstats, fieldInfoMap, mappingObject, conversionType, TransformerInfo, functionMap, SplitKeyConfig, RecipientListType } from "../types/types";
import Encryptor from "jsencrypt";
import { EnvironmentRegistry } from "./registry/environmentRegistry";
import { getEnvToken } from "./configComparatorService";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "./networkService";


import store from "../stateManagement/store";

export async function getIntegrationConfig() {
  const response = await ChannelkartNetworkGet("/metadata/clientconfig?name=integrationTool");
  return response.data.features;
}

export async function getIntegrationEntities(): Promise<IntegrationEntity[]> {
    const response = await ChannelkartNetworkGet("/entityInfos/integrationEntities");
    if(response.status === 200 || response.status === 201){
      return response.data.features.sort((a:IntegrationEntity, b:IntegrationEntity) => a.entityName.localeCompare(b.entityName));
    } else {
      return [];
    }
}

export async function getFileMetaFromProfile(profileName:string): Promise<RemoteFileInfo[]> {  
    const response = await ChannelkartNetworkGet(`/rstreams/${profileName}/files`);
    if(response.status === 200 || response.status === 201){
      return response.data.features;
    } else return [];
}

export function encryptPassword(data: string): string {
  const encryptor = new Encryptor();
  const publicKey ="-----BEGIN PUBLIC KEY-----\nMIIEIjANBgkqhkiG9w0BAQEFAAOCBA8AMIIECgKCBAEAtPfb7ojAl9ooCs/VdFJqLOOwnyGXO/DcB2dKPjwQQucjaOWn0R2zK+6NDpSd7IuA4iFdYq9DAgM4L5rm25AI7z3hu8e9l61Q+6J+/XegFMQidEWErzU+wVWYipCpPSJwivqIuJcrIz9NhJ2S0SeRe9f45Mq7LI5GRWSrN7TDu3WY7l1TBeywQLwRiGde+ZNcJ6T4RlZIRZoRSSRXJ6ubDeTXHge/41TbcXWcUJ1Q9DBy0txoCKCQVU6Au9rHkx+Ah+FyMW5ivU5EWyTUrSHrBnxEDPXqbLgg47y9oG3cvzjGLnxjJWYyeBY31v7lT+nPenwNX845COIo8r0iVylPr9lv3fUmzYrkUwF4UGlIKlM6FjBI66QcXR+N8RQK5PeQxRkMxzDWZKpYhp2jnHTzf9ugTOaAIQ/fl8KETVGfPPCe8xzaGYcfdPP9vgV5IQbF5rb9vFz/Jm29zVY1e3GMsdStqVeTquxA2BtNuKZeMNU6cqCSM6x0YoIgMjTdLMbMIeOIhAVW52m7DiQB3PmIkn65fwf+B3+3CIM4xmMSNMu7zLLJxDQ5Gw6vIr7BRDUny1peeAvc+/i+H7cDcfH3W0bKwpNYGLIXhUHP03eQLE0xfo4F5Cy2wl15OmL04cU1YumlJe4G2B1edHyEfdcynINPdOsGs/bnLkp4fGV29DTyeodkbZTyPH4Q16+FPDasEsqviRGbB8R33oM1MjMoq1EVXN9XZPblopkTnFefgN7ieyALHh/FSFCr4NHIAHD6+Zk7U5/cNLrRia4yoiuB16EHXJhgiahrHosIO0tzqTEUS1LgnuYFR/gezYKryE5Voh41ycGxC0GZc8WEyh8wozjVK2uFtvQJNqhKaV4jhs09IPf4g+L7H8br5otU7+9zgUsW8NaNoU1lcDtihYHgtYr+BN84wfkRrrm7+ipW8aOf31uhMQozNKPSPJ0VSygmIPAJ8aZ7NlAnmhRscd5HyZsp9D6zQPJ3+gullXwIAqTDBT+hBXMozHGYH0UUwjL2zncRlPMMdf9e21csNV4sD8AODVaNRMwJcIX9hhHuDGW3RqqFWTwWJgeIdX3q/kICxuyy1n0Rn50+kEsf/gxhjaGoTv3ZqdSvdANL9RnY3FRIgej1tUoejPQNH3cACnhaOThPsDXumydCLUmJydrlzmqI1BLsVX/J/Q6fv+8marA9N6hyW5BffH9onoGXvi9wSSQQAArvdUIQiTw/47tM/1EXaIIb3oVA08K7bkDeHOhVcaQ8Ww89xYE6p6MaN8hKobGFF/pj4ia1Ml882g0j6sE7iKkmPnhv0qiXqAy5yfedtW3a6rhNDe7VPKLqKOxvBPhGdvsqDc74J3viUSz0HwIDAQAB\n-----END PUBLIC KEY-----";
  encryptor.setPublicKey(publicKey);
  const encryptedData = encryptor.encrypt(data);
    if (encryptedData === false) {
      throw new Error("Could not encrypt");
    }
    return encryptedData;
}

export async function getConnectionConfigurations(): Promise<any> {
  const response = await ChannelkartNetworkGet(`/rstreams?size=200`);
  return response.data.features;
}

export async function getProfileByName(name:string) {
  try{
    const response = await ChannelkartNetworkGet(`/profiles/name/${name}`);
    return response;
  } catch (error) {
    return error;
  }
}

export async function updateConnectionProfiles(connectionProfile : connectionProfileType) {
  try {
    const response = await ChannelkartNetworkPut(`/rstreams/profiles/${connectionProfile.name}?saveOnConnection=true`,connectionProfile);
    return response;
  } catch (error) {
    return {status:500};
  }
}

export async function saveIntegrationSchedule(integrationSchedule:IntegrationSchedule) : Promise<{data:any,status:any}>{
  const response = await ChannelkartNetworkPut(`/rstreams/schedules/${integrationSchedule.jobName}`,JSON.stringify(integrationSchedule),{"Content-Type": "application/json"});
  return response;
}

export async function getMediaOutProfiles(lob:string,typesList:string) : Promise<connectionProfileType[]>{
  const filters = `&lob=${lob}&filter=type[in]:[${typesList}]&sort=type:asc,name:asc`;
  const response = await ChannelkartNetworkGet(`/profiles?size=200${filters}`);
  if(response.status === 200 || response.status === 201){
      return response.data.features;  
  } else return [];
}
export async function getIntegrationSchedules(lob:string):Promise<IntegrationSchedule[]>{
  const response = await ChannelkartNetworkGet(`https://integrationtool.sellina.io/integration/schedules?lob=${lob}`);
  if(response.status === 200 || response.status === 201) 
    return response.data as IntegrationSchedule[];
  else return [];
}

export async function updateMediaProfiles(lob:string,mediaProfile : connectionProfileType , isAdd : boolean){
  const id = mediaProfile.id;
  delete mediaProfile.payload;
  if(isAdd){
    const response = await ChannelkartNetworkPost(`/profiles?lob=${lob}`,mediaProfile);
    return response.data;
  }
  else {
    const response = await ChannelkartNetworkPut(`/profiles/${id}?lob=${lob}`,mediaProfile);
    return response.data;
  }
}

export async function getIntegrationFileInfo(remoteStreamLoadFile:RemoteStreamLoadFile): Promise<IntegrationFileInfo[]> {
  const response = await ChannelkartNetworkPost(
    `/rstreams/${remoteStreamLoadFile.profile}/files/load`,
    JSON.stringify(remoteStreamLoadFile),
    { "content-type": "application/json" }
  );
  if(response.status !== 200 && response.status !== 201) return [];
  let dataObject: IntegrationFileInfo[] = [];
  dataObject[0]=response.data.features[0];
  if(isUndefinedorEmpty(dataObject[0].ig)){
    throw new Error("No data found in the file");
  }
  dataObject[0].fileName = remoteStreamLoadFile.fileName;
  dataObject[0].size = remoteStreamLoadFile.size;
  dataObject[0].lastmodified = remoteStreamLoadFile.lastmodified;
  dataObject[0].entityName = remoteStreamLoadFile.entityName;
  dataObject[0].recordCount = Number(dataObject[0].ig[0].total);
  return dataObject;
}

export async function getMapperInformation(entityName:string,lob:string):Promise<IntegrationMapper[]> {
  let dataList: IntegrationMapper[] = [];
  const mapperResponse = await ChannelkartNetworkGet(`https://integrationtool.sellina.io/integration/mappers?lob=${lob}`);
  const transfomerResponse = await ChannelkartNetworkGet(`/v1/transformers`);
  type apiRes = {
    id: string; name: string; code: any; type: string; implementation: string;
  }
  if(transfomerResponse.status === 200 || transfomerResponse.status === 201)
  dataList = dataList.concat(transfomerResponse.data.features.filter((data: apiRes) => data.type === entityName).map((data: apiRes) => {
    let mapperInfo: IntegrationMapper = {
      id: data.id,
      mapperName: data.name,
      type: "db",
      config: data.code ? data.code : "",
      entityName: data.type,
      implementation: data.implementation
    };
    return mapperInfo;
  }));
  type mapperRes = { name: string; mapper: any; type: string; }
  if(mapperResponse.status === 200 || mapperResponse.status === 201)
  dataList = dataList.concat(mapperResponse.data.filter((mapper:mapperRes) => mapper.type === entityName).map((data:mapperRes) => {
    let mapperInfo: IntegrationMapper = {
      id: data.name,
      mapperName: data.name,
      type: "dynamo",
      config: data.mapper,
      entityName: data.type,
    };
    return mapperInfo;
  }));
  return dataList;
}

export async function saveSalesMapper(requestObject:SalesMapperRequest):Promise<{data:any,status:any}>{
  const response = await ChannelkartNetworkPut(`https://integrationtool.sellina.io/integration/mappers`,JSON.stringify(requestObject),{"Content-Type": "application/json"});
  return response;
}

export async function getRootSplitKeys(rootData:boolean=false){
  const response = await ChannelkartNetworkGet(`/metadata/splitkeys?name=splitkeysoptions&rootData=${rootData}`);
  if(response.status===200 || response.status===201){
    return response.data;
  } else {
    return [];
  }
}

export async function getLobSplitKeys(){
  const response = await ChannelkartNetworkGet(`/metadata/splitkeys`);
  return response;
}

export async function postLobSplitKeys(splitKeys:SplitKeyConfig[]){
  const response = await ChannelkartNetworkPost(`/metadata`,splitKeys);
  return response
}

export async function getEntityFieldMappingInfo(entityName : string, lob : string){
  const response = await ChannelkartNetworkGet(`/entityInfos/info/?name=${entityName}&lob=${lob}`);
  return response.data.features[0].fieldInfoMap;
}

export async function getFunctionDetails(lob: string){
  const response = await ChannelkartNetworkGet(`/v1/functions?lob=${lob}`);
  return response.data.features;
}

export async function checkTransformerName(transformerName:string) {
  const response = await ChannelkartNetworkGet(`/v1/registry/data/transformerInfo/${transformerName}`)
  if(response.status===200 || response.status===201){
    if(!isUndefinedorEmpty(response.data.features) && Array.isArray(response.data.features) && response.data.features.length > 0) {
        return true;
    }
    else return false;
  }
  return false;
}

export async function saveMappingTransformer(httpVerb:string, httpPUTEndpoint:string, transformerJSON: string):Promise<{data:any,status:any}>{
  const url = `/v1/registry/data/transformerInfo/${httpPUTEndpoint}`
  if(httpVerb === "POST"){
    return await ChannelkartNetworkPost(url,transformerJSON,{"Content-Type": "application/json"});
  } else {
    return await ChannelkartNetworkPut(url,transformerJSON,{"Content-Type": "application/json"});
  }
}

export async function getRegisteredFunctions(){
  const response = await ChannelkartNetworkGet(`/v1/functions`);
  return response;
}

export async function saveRegisteredFunction(functions:functionMap,httpVerb:string, httpPUTEndpoint:string){
  const url = `/v1/registry/data/functionInfo/${httpPUTEndpoint}`;
  if(httpVerb === "POST"){
    return await ChannelkartNetworkPost(url,functions);
  } else {
    return await ChannelkartNetworkPut(url,functions);
  }
}

export async function fetchIntegrationHistory(env : string, lob : string ){
    const response = await ChannelkartNetworkGet(`https://integrationtool.sellina.io/history/integrations?env=${env}&lob=${lob}`);
    return response.data;
}

export async function fetchIntegrationjobsV2(payload:any) : Promise<IntegrationJobstats[]> {
  const response = await ChannelkartNetworkPost(`https://integrationtool.sellina.io/jobs/integrations`,JSON.stringify(payload),{ "content-type": "application/json" });
  if(response.status === 200 || response.status === 201){
    return response.data.features;
  }
  else {
    return []
  };
}
export async function fetchIntegrationjobsProfileData(profileId:string,lob:string)  {
try{
  const response = await ChannelkartNetworkGet(`https://uat.sellina.io/profiles/name/${profileId}?lob=${lob}`);

  if (response.status === 200) {
    return response
  } else {
    throw new Error(`Request failed with status ${response.status}`);
  }
} catch(error){
    console.error("Error fetching profile data:", error);
    throw error; 
}
}
  
  

 
  


export async function saveMapping(isBusy: boolean, setIsBusy: React.Dispatch<React.SetStateAction<boolean>>, configureList: mappingObject[], mapperName: string, columnList: fieldInfoMap[], transformer: IntegrationMapper, isNew: boolean, onClose: () => void,fileInfo: IntegrationFileInfo,) {
  if (isBusy) {
      alert("Upload is in progress");
      setIsBusy(false);
      return;
  }
  setIsBusy(true);
  if(isUndefinedorEmpty(configureList) || configureList.length === 0) {
      alert("No data in mapping to create Transformer");
      setIsBusy(false);
      return;
  }
  if(isUndefinedorEmpty(mapperName)|| mapperName.trim().length === 0) {
      alert("Transformer name cannot be empty");
      setIsBusy(false);
      return;
  }
  const selectedFields = configureList.map((mapping) => mapping.to);
  const missingMandatoryFields = columnList.filter((field) => checkIfMandatory(field) && !selectedFields.includes(field.name));
  if(missingMandatoryFields.length > 0) {
      alert("Mandatory fields are not mapped:\n" + missingMandatoryFields.map(s=>s.name).join(", "))
      return;
  }
  const transformerJSON = prepareTransformerJSON(transformer,mapperName,configureList,isNew,fileInfo);
  if(isUndefinedorEmpty(transformerJSON)) {
      alert("No data in mapping to create Transformer")
      setIsBusy(false);
      return;
  }
  let httpVerb, httpPUTEndpoint;
  if(isNew) {
      let transformerFound = await checkTransformerName(mapperName);
      if(transformerFound === true){
          alert("Transformer with same name already exists. Use a different name.")
          setIsBusy(false);
          return;
      }
      httpVerb="POST";
      httpPUTEndpoint='';
  } else {
      httpVerb="PUT";
      httpPUTEndpoint=mapperName;
  }

  const response = await saveMappingTransformer(httpVerb, httpPUTEndpoint, JSON.stringify(transformerJSON));
  if(response.status === 200 || response.status === 201) {
      alert("Transformer saved successfully");
      setIsBusy(false);
      onClose();
  }
  else {
      alert("Error saving Transformer");
  }
  setIsBusy(false);
}

export const checkIfMandatory = (field: fieldInfoMap) => {
  if (field.jsonIgnore && !field.isMandatory) {
      return false;
  }
  else if (field.isMandatory || field.notNull) {
      return true;
  }
  return false;
}

function prepareTransformerJSON(existingTransformer:IntegrationMapper,mapperName:string,configureList:mappingObject[],isNew:boolean,fileInfo: IntegrationFileInfo):(TransformerInfo|null){
  let jsonArr = [];
  let extendedAttr = [];
  for(let i = 0;i<configureList.length;i++){      
      let mapping:mappingObject = configureList[i];
      if(isUndefinedorEmpty(mapping) || !mapping.hasOwnProperty('to') || isUndefinedorEmpty(mapping.to)) {
          continue; // skipped if target field is empty
      }
      else {
          if(mapping.to.toLowerCase() === 'extendedattributes') {
              extendedAttr.push(mapping);
          }
          else {
              jsonArr.push(mapping);
          }
      }
  }
  if(jsonArr.length === 0 && extendedAttr.length === 0) {
      return null;
  }

  let result:mappingObject[] = jsonArr;
  if(extendedAttr.length !== 0) {
      let extAttr:mappingObject = {from: [], to: '', conversions: []}
      extAttr.to = 'extendedAttributes';
      for(let extMap of extendedAttr) {
          for(let indvFrom of extMap.from) {
              extAttr.from.push(indvFrom);
          }
      }
      let extfunctionMap:conversionType = {functionName: null, unRegisteredFunction: null, constInput: {}, recordInput: {}};
      extfunctionMap.functionName = 'toMap';
      extfunctionMap.constInput = {keys: []};
      extfunctionMap.recordInput = {values:[]}
      for(let entryValue of extAttr.from) {
          extfunctionMap.constInput.keys.push(entryValue);
          extfunctionMap.recordInput.values.push(entryValue);
      }
      extAttr.conversions.push(extfunctionMap);
      result.push(extAttr);
  }

  let transformerToBeCreated:TransformerInfo = {} as TransformerInfo;
  transformerToBeCreated.code=result;
  transformerToBeCreated.id=mapperName;
  transformerToBeCreated.name=mapperName;
  transformerToBeCreated.enabled=true;
  transformerToBeCreated.language="java";
  transformerToBeCreated.implementation='com.applicate.services.mappingservice.transfomers.impl.IntegrationServiceTransfomer';
  if(isNew) {
      transformerToBeCreated.version=1;
      transformerToBeCreated.type=fileInfo.entityName;    
  } else {
      transformerToBeCreated.type = existingTransformer.entityName;
  }
  return transformerToBeCreated;
}

export const convertToStringList = (stringToParse: string,setHeaders:React.Dispatch<React.SetStateAction<string[]>>,isNew:boolean,defaultMappingState:mappingObject,setConfigureList:React.Dispatch<React.SetStateAction<mappingObject[]>>) => {
  const list: string[] = JSON.parse(stringToParse);
  setHeaders(list);
  if (isNew) {
      const newMappingList: mappingObject[] = [];
      list.forEach((mappingObj) => {
          const newMapping: mappingObject = { ...defaultMappingState };
          newMapping.from = [mappingObj];
          newMappingList.push(newMapping);
      });
      setConfigureList(newMappingList);
  }
}

export const ModalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "90%",
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

export const ITEM_HEIGHT = 48;
export const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
      style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
      },
  },
};
export function getStyles(selectedOption: string, selectList: readonly string[], theme: Theme) {
  return {
      fontWeight:
          selectList.indexOf(selectedOption) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium
  };
}

export const checkObjectInRecordInput = (parameter: string, inputConversions: mappingObject) => {
  if (parameter in inputConversions.conversions[0].recordInput && inputConversions.conversions[0].recordInput[parameter].filter(colName => !isUndefinedorEmpty(colName)).length > 0) {
    return true;
  } else {
    return false;
  }
}

export const checkObjectInConstInput = (parameter: string, inputConversions: mappingObject) => {
  if (parameter in inputConversions.conversions[0].constInput && inputConversions.conversions[0].constInput[parameter].filter(colName => !isUndefinedorEmpty(colName)).length > 0) {
    return true;
  } else {
    return false;
  }
}

export function parseDateToLocalString(date : string){ 
  const dateTimeArr=date.split(' '); 
  const dateArr=dateTimeArr[0].split('-'); 
  const newDate=dateArr[1]+'-'+dateArr[0]+'-'+dateArr[2]+' '+(dateTimeArr[1] || '00:00:00')+' UTC'; 
  const dateStr= new Date(newDate).toLocaleString();
  return dateStr.substring(0,dateStr.lastIndexOf(':'));
}

export function getRecipientList(schemaName:string):Promise<{data: any,status: number}>{
  return ChannelkartNetworkGet(`/models/${schemaName}`)
}

export function saveRecipientListSchema(schemaName:string,schema:any):Promise<{data: any,status: number}>{
  return ChannelkartNetworkPut(`/models/schema/${schemaName}/`, JSON.stringify(schema), { "Content-Type": "application/json" })
}

export function saveRecipientList(schemaName:string,id:string,body:RecipientListType):Promise<{data: any,status: number}>{
  return ChannelkartNetworkPut(`/models/${schemaName}/${id}`, JSON.stringify(body), { "Content-Type": "application/json" })
}

export async function getServerList() {
  const response = await ChannelkartNetworkGet("https://analytics.sellina.io/stats/servers");
  return response.data;
}
const Analytics_DASHBOARD_URL = "https://analytics.sellina.io"
export async function getRulesTable(lob:string) {
  const response = await ChannelkartNetworkGet(`${Analytics_DASHBOARD_URL}/stats/db?lob=${lob}`);
  return response;
}
export async function getValidationTable(searchParam:string, lob:string) {
  const response = await ChannelkartNetworkGet(`${Analytics_DASHBOARD_URL}/stats/databaseRules?lob=${lob}&dataModel=${searchParam}`);
  return response;
}
export async function getUpdatedValidationTable(ruleId:string,activeStatus:string, searchParam:string, lob:string) {
  const response = await ChannelkartNetworkGet(`${Analytics_DASHBOARD_URL}/updateResult?lob=${lob}&ruleId=${ruleId}&model=${searchParam}&activeStatus=${activeStatus}`);
  return response;
}

export async function getViewButtonData(ruleId:string,lob:string, page:number){
  const response = await ChannelkartNetworkGet(`${Analytics_DASHBOARD_URL}/query?lob=${lob}&ruleId=${ruleId}&page=${page}`);
  return response;

}
export async function getViewButtonRecords(ruleId:string,lob:string){
  const response = await ChannelkartNetworkGet(`${Analytics_DASHBOARD_URL}/dataSize?lob=${lob}&ruleId=${ruleId}&page=1`);
  return response;

}
export async function getSlowQueryData(lob:string,env:string){
  const response = await ChannelkartNetworkGet(`${Analytics_DASHBOARD_URL}/slowqueries?lob=${lob}`,undefined,{env: `${env}` ,lob:`${lob}`});

  return response;

}
export async function getFailedReports(lob:string,ruleId:string){
  const response = await ChannelkartNetworkGet(`${Analytics_DASHBOARD_URL}/failReport?lob=${lob}&ruleId=${ruleId}`);
  return response;

}
export async function getMasterDataReports(){
  const response = await ChannelkartNetworkGet("https://analytics.sellina.io/reports");
  return response;
}
export async function getOrderStats(){
  const response = await ChannelkartNetworkGet("https://analytics.sellina.io/stats/orders");
  return response;
}
export async function getSyncedOrderStats(){
  const response = await ChannelkartNetworkGet("https://analytics.sellina.io/stats/syncedOrders");
  return response;
}
